<template>
  <div>
    <div class="mrB20" />
    <ur-data-grid
      ref="gridLinkRole"
      :headers="columnLinkRole"
      :options="LinkRoleOptions"
      :data-source="dsLinkRole"
    />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onModClick"
      >
        {{ $t('MSG_BTN_EDIT') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import {urDataSet} from 'uidev-component/index.js';
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;

/* eslint max-len: ["error", { "code": 200 }] */
export default {
  name: 'PGE_CMP_00027_T03', // eslint-disable-line vue/name-property-casing
  components:{
    urDataGrid,
  },
  extends: BasePage,
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dsLinkRole: new urDataSet(),
      LinkRoleOptions: {
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
      },
      roleObjectTypeCode: 'L', // Application
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (selectObj) {
        this.roleListLoad();
      } else {
        this.tabGridClear();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedGridRowData)) {
        this.roleListLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  created() {
    this.columnLinkRole = [
      {
        value: 'taskName',
        text: this.$t('MSG_TXT_TASK_TYPE'),
        rules: undefined,
      },
      {
        value: 'roleId',
        text: this.$t('MSG_TXT_ROLE_ID'),  
        rules: undefined,
      },
      {
        value: 'roleName',
        text: this.$t('MSG_TXT_ROLE_NAME'),
        rules: undefined,
      },
    ];
  },
  methods: {
    roleListLoad() {
      if (this.selectedGridRowData) {
        http.request(this.contextPageId, 'DTS_CMA_00040', {
          query: {
            roleObjectId: this.selectedGridRowData.linkId,
            roleObjectTypeCode: this.roleObjectTypeCode,
          },
        }).then(res => {
          utils.forEach(res.data, item => {
            const { roleName, taskName } = item.roleInfo;
            utils.assign(item, {
              roleName,
              taskName,
            });
          });
          this.dsLinkRole.setData(res.data);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    tabGridClear() {
      this.$refs.gridLinkRole.gridLinkParam();
    },
    onModClick() {
      if (utils.isEmpty(this.selectedGridRowData)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_APPLICATION')));
      } else {
        utils.openLayerPopup('PGE_CMU_00015', this.onPopupClose, {
          pageInitialData: {
            roleObjectId: this.selectedGridRowData.linkId,
            roleObjectTypeCode: this.roleObjectTypeCode,
          },
          size: 'xlg',
        });
      }
    },
    onPopupClose(saved) {
      if (saved) {
        this.roleListLoad();
      }
    },
  },
};
</script>
<style scoped>
</style>
